import { useEffect } from "react";

export const Candlelight = () => {
  useEffect(() => {
    const el = document.getElementById("candle-glow");
    if (!el) return;
    let x = window.innerWidth / 2;
    let y = window.innerHeight * 0.42;
    let tx = x;
    let ty = y;
    let raf;
    const onMove = (e) => {
      x = e.clientX;
      y = e.clientY;
    };
    const loop = (t) => {
      tx += (x - tx) * 0.055;
      ty += (y - ty) * 0.055;
      const flicker =
        0.72 +
        Math.sin(t / 170) * 0.1 +
        Math.sin(t / 47) * 0.08 +
        Math.sin(t / 23) * 0.05;
      const alpha = Math.max(0.05, 0.16 * flicker);
      el.style.background = `radial-gradient(560px circle at ${tx}px ${ty}px, rgba(255, 190, 92, ${alpha}), rgba(226, 177, 93, ${alpha * 0.35}) 42%, transparent 70%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div
        id="candle-glow"
        data-testid="candlelight-glow"
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-30 mix-blend-screen"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-30"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 52%, rgba(4, 3, 2, 0.55) 100%)",
        }}
      />
    </>
  );
};
